import settingsService from "../services/settings.service";
import { GET_SETTINGS, GET_SETTINGS_PROMOTER_LIST } from "./types";

export const getSettingsAction = () => async (dispatch) => {
  return settingsService.getSettings().then((resp) => {
    dispatch({ type: GET_SETTINGS, payload: resp.status ? resp.data : {} });
    dispatch({ type: GET_SETTINGS_PROMOTER_LIST, payload: resp.status ? resp.defaultList : [] });
  });
}